import React, { Component } from "react";
import { Modal } from "reactstrap";

import ModalStyles from "./Modal.css";
import AddressPickerStyles from "./AddressPickerModal.css";

/* eslint-disable import/no-webpack-loader-syntax */

import CloseIcon from "-!svg-react-loader!../icons/close.svg";

class AddressPickerModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: this.props.open,
      addresses: [],
      billingAddress: null,
      deliveryAddress: null
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      modal: nextProps.open,
      addresses: nextProps.addresses,
      billingAddress: nextProps.billingAddress,
      deliveryAddress: nextProps.deliveryAddress
    });
  }

  select = address => {
    if (
      (this.props.currentSelector === "billing" &&
        this.state.billingAddress.id === address.id) ||
      (this.props.currentSelector === "delivery" &&
        this.state.deliveryAddress.id === address.id)
    ) {
    } else {
      this.props.updateAddress(this.props.currentSelector, address);
    }
  };

  toggle = () => {
    // this.setState({
    //     modal: !this.state.modal
    // });
    this.props.toggle();
  };

  render() {
    return (
      <Modal
        isOpen={this.state.modal}
        toggle={this.toggle}
        className='address-picker-modal'
      >
        <CloseIcon
          className='close-btn'
          onClick={() => {
            this.toggle();
          }}
        />
        <div className='body'>
          <h2>Select an address</h2>
          {this.state.addresses.length === 0 ? (
            <div className='addresses'>Loading</div>
          ) : (
            <div className='addresses'>
              {this.state.addresses.map((item, i) => {
                return (
                  <div
                    onClick={() => {
                      this.select(item);
                    }}
                    className={
                      "entry address " +
                      ((this.props.currentSelector === "billing" &&
                        item.id === this.state.billingAddress.id) ||
                      (this.props.currentSelector === "delivery" &&
                        item.id === this.state.deliveryAddress.id)
                        ? "selected"
                        : "")
                    }
                  >
                    {window.region === "SG" && (
                      <div>
                        <p>{item.address1}</p>
                        <p>{item.address2}</p>
                        <p>{item.address3}</p>
                      </div>
                    )}
                    {window.region === "MY" && (
                      <div>
                        <p>{item.address1My}</p>
                        <p>{item.address2My}</p>
                        <p>{item.cityMy}</p>
                        <p>{item.postalCodeMy}</p>
                        <p>{item.stateMy}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </Modal>
    );
  }
}

export default AddressPickerModal;



// WEBPACK FOOTER //
// ./src/components/AddressPickerModal.js